module.exports = __webpack_public_path__ + "static/team-horizontal-4ecaa9fa6bed273fe22b2686828a5a57.jpg";